/**
 * The pool cue styles (UI-019, owner 2026-09-27).
 *
 * Like the table themes, a style is nothing but a swapped token set: its colours live in
 * `styles/tokens.css`, under `[data-cue='<id>']`. This file only names them and says
 * which are free. Classic is free; the five others belong to the supporter pack
 * (D-044, D-047) and are offered only once it is released, or in debug mode on the
 * local development server. As with themes, whether a player OWNS one will be the
 * server's decision (THM-002); a setting in the browser is UX, not access control.
 */
import type { ThemeTier } from './themes.ts';

export interface CueInfo {
  readonly id: string;
  readonly name: string;
  readonly tier: ThemeTier;
}

export const CUE_STYLES = [
  { id: 'classic', name: 'Classic maple', tier: 'free' },
  { id: 'ebony-brass', name: 'Ebony & brass', tier: 'premium' },
  { id: 'carbon', name: 'Carbon black', tier: 'premium' },
  { id: 'rosewood', name: 'Rosewood', tier: 'premium' },
  { id: 'ocean', name: 'Deep ocean', tier: 'premium' },
  { id: 'royal', name: 'Royal purple', tier: 'premium' },
] as const satisfies readonly CueInfo[];

export type CueStyleId = (typeof CUE_STYLES)[number]['id'];

export const DEFAULT_CUE: CueStyleId = 'classic';

export function isCueStyleId(value: unknown): value is CueStyleId {
  return typeof value === 'string' && CUE_STYLES.some((cue) => cue.id === value);
}

/** The styles a player is offered: all of them once unlocked, else the free one. */
export function offeredCues(unlocked: boolean): readonly CueInfo[] {
  return unlocked ? CUE_STYLES : CUE_STYLES.filter((cue) => cue.tier === 'free');
}

/** A style offered right now. A saved one that is not falls back to the default. */
export function isOfferedCue(value: unknown, offered: readonly CueInfo[]): value is CueStyleId {
  return isCueStyleId(value) && offered.some((cue) => cue.id === value);
}
